import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui';
import { Check } from 'lucide-react';
const icons = {
  nlp: <svg className="w-12 h-12 text-gold mb-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-208">
      <path d="M12 22v-5" data-id="element-209" />
      <path d="M9 8V2" data-id="element-210" />
      <path d="M15 8V2" data-id="element-211" />
      <path d="M12 2v6" data-id="element-212" />
      <path d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z" data-id="element-213" />
      <path d="M5 12h2" data-id="element-214" />
      <path d="M17 12h2" data-id="element-215" />
      <circle cx="12" cy="12" r="2" data-id="element-216" />
    </svg>,
  workshop: <svg className="w-12 h-12 text-gold mb-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-217">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" data-id="element-218" />
      <path d="M21 12a9 9 0 1 1-9-9" strokeDasharray="4 4" data-id="element-219" />
    </svg>,
  team: <svg className="w-12 h-12 text-gold mb-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-220">
      <circle cx="12" cy="7" r="4" data-id="element-221" />
      <path d="M12 11v4" data-id="element-222" />
      <path d="M8 15h8" data-id="element-223" />
      <circle cx="8" cy="19" r="2" data-id="element-224" />
      <circle cx="16" cy="19" r="2" data-id="element-225" />
      <path d="M12 15l-4 4" data-id="element-226" />
      <path d="M12 15l4 4" data-id="element-227" />
    </svg>
};
const services = [{
  icon: icons.nlp,
  image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  imageAlt: 'Participanți la cursul NLP Practitioner',
  title: 'NLP Practitioner',
  subtitle: 'Program de formare certificat, 7 luni online live',
  benefits: ['7 module practice, un weekend pe lună', 'Tehnici reale de schimbare, nu teorie', 'Certificare NLP națională și internațională', 'Suport online între module, 6 sesiuni incluse', 'Reparticipare gratuită la ediția următoare'],
  cta: 'Vezi detalii program'
}, {
  icon: icons.workshop,
  image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  imageAlt: 'Workshop interactiv cu participanți',
  title: 'Workshop NeuroReset',
  subtitle: 'Training gratuit pe o problemă concretă',
  benefits: ['Online sau fizic, format scurt și aplicat', 'Teme: obiective, comunicare, emoții, blocaje', 'Exerciții practice pe care le folosești imediat', 'Primul pas înainte de un program mai lung', 'Fără costuri, fără obligații'],
  cta: 'Mă înscriu la workshop'
}, {
  icon: icons.team,
  image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  imageAlt: 'Echipă de profesioniști în training',
  title: 'Team Architects',
  subtitle: 'Traininguri NLP pentru echipe și companii',
  benefits: ['Comunicare mai bună între departamente', 'Reducerea conflictelor și a fluctuației de personal', 'Tehnici de leadership și motivare a echipei', 'Workshopuri personalizate pe nevoile firmei', 'Rezultate măsurabile în comportamentul echipei'],
  cta: 'Vreau detalii'
}];
export const Services = () => {
  return <section id="servicii" className="py-24 bg-navy relative" data-id="element-228">
      <div className="container mx-auto px-6" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-230">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-231">
            Cum poți lucra cu noi
          </h2>
          <p className="font-display text-textSub text-lg" data-id="element-232">
            Alege formatul care ți se potrivește cel mai bine acum.
          </p>
        </motion.div>
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-233">
          {services.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-navy-card border border-gold/30 flex flex-col h-full hover:border-gold/60 transition-colors duration-300 overflow-hidden" data-id="element-234">
              {/* Service Image */}
              <div className="relative h-48 w-full overflow-hidden" data-id="element-235">
                <img src={service.image} alt={service.imageAlt} className="w-full h-full object-cover" data-id="element-236" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-card via-navy-card/40 to-transparent" data-id="element-237" />
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-238">
                <div className="mb-8" data-id="element-239">
                  {service.icon}
                  <h3 className="font-serif text-3xl font-bold text-white mb-2" data-id="element-240">
                    {service.title}
                  </h3>
                  <p className="font-display text-gold text-sm font-semibold" data-id="element-241">
                    {service.subtitle}
                  </p>
                </div>
                <ul className="space-y-4 mb-10 flex-grow" data-id="element-242">
                  {service.benefits.map((benefit, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-243">
                      <Check className="w-5 h-5 text-gold shrink-0 mt-0.5" data-id="element-244" />
                      <span className="font-sans text-textLight/80 text-sm" data-id="element-245">
                        {benefit}
                      </span>
                    </li>)}
                </ul>
                <div className="mt-auto" data-id="element-246">
                  <Button variant="primary" className="w-full" data-id="element-247">
                    {service.cta}
                  </Button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};